import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	allSites: {
		id: 'navigation.global-shortcuts.all-sites',
		defaultMessage: 'All sites',
		description: 'The "all sites" menu label in expand menu',
	},
	closeButtonAriaLabel: {
		id: 'navigation.global-shortcuts.menu-expand-item.close-button-aria-label',
		description: 'Close button for menu expand item content',
		defaultMessage: 'Close',
	},
});
